module.exports = __webpack_public_path__ + "img/hero-bg-petcare.5cf7f038.jpg";